var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12 7.5c.41475 0 .75.33525.75.75s-.33525.75-.75.75h-6v9h9v-6c0-.41475.33525-.75.75-.75s.75.33525.75.75v6.75c0 .41475-.33525.75-.75.75h-10.5c-.41475 0-.75-.33525-.75-.75v-10.5c0-.41475.33525-.75.75-.75zm6.7500003-3c.41475 0 .7500001.33525001.7500001.75000003v6.74999997c0 .4147503-.3352501.7500003-.7500001.7500003s-.75-.33525-.75-.7500003v-4.93949991l-7.0560002 7.05675021c-.29325.2925-.7687501.2925-1.06125007 0-.29250001-.2925-.29250001-.768 0-1.06125l7.05675027-7.0560003h-4.9395002c-.41475 0-.75-.33524996-.75-.74999997 0-.41475002.33525-.75000003.75-.75000003z","transform":"translate(-4 -4)"}));
}

ExternalLink.defaultProps = {"height":"16","viewBox":"0 0 16 16","width":"16"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
